export const fps = [
  { id: '24', name: '24 fps' },
  { id: '25', name: '25 fps (PAL)' },
  { id: '29.97', name: '29.97 fps (NTSC)' },
  { id: '30', name: '30 fps' },
  { id: '50', name: '50 fps' },
  { id: '60', name: '60 fps' },
] as const
